























import { Component, Vue, Prop } from "vue-property-decorator";
import { HelpGetCouponRuleConfig } from "./model/helpGetCouponRuleConfig";
import CouponSelect from "@/components/coupon-select/index.vue";
import CouponTable from "../couponTable/index.vue";
import CouponDto from "../coupon/model/couponDto";

@Component({
  components: {
    CouponSelect,
    CouponTable
  }
})
export default class HelpGetCoupon extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        memberScope: "All",
        memberTags: [],
        cumulativeWithOtherDiscount: false,
        discounts: [],
        duration: 0,
        helpCount: 0,
        freeCoupons: [],
        coupons: [],
        successCoupon: ""
      };
    }
  })
  value!: HelpGetCouponRuleConfig;

  onFreeCouponRowSelected(e) {
    console.log(e);
    this.$set(this.value, "freeCoupons", [e]);
  }
  onRowSelected(e) {
    this.$set(this.value, "coupons", [e]);
  }
}
